import { useMemo } from 'react'
import {
	Editor,
	EditorProvider,
	Toolbar,
	BtnBold,
	BtnItalic,
	BtnUnderline,
	BtnNumberedList,
	BtnBulletList,
	BtnLink,
	BtnClearFormatting,
	createButton,
} from 'react-simple-wysiwyg'

const BtnAlignLeft = createButton('Align left', 'L', 'justifyLeft')
const BtnAlignCenter = createButton('Align center', 'C', 'justifyCenter')
const BtnAlignRight = createButton('Align right', 'R', 'justifyRight')

const toHtmlString = value => {
	if (typeof value === 'string') return value
	if (value === undefined || value === null) return ''
	return String(value)
}

export default function ProjectRichTextEditor({
	id = 'project-opis',
	value = '',
	onChange,
	placeholder = '',
}) {
	const resolvedValue = useMemo(() => toHtmlString(value), [value])

	return (
		<div className="project-rich-text-editor overflow-hidden rounded-md border border-gray-300 bg-white focus-within:border-indigo-600 focus-within:ring-1 focus-within:ring-indigo-600">
			<EditorProvider>
				<Editor
					id={id}
					value={resolvedValue}
					onChange={event => onChange?.(event?.target?.value ?? '')}
					placeholder={placeholder}
					containerProps={{
						style: {
							minHeight: '160px',
							resize: 'vertical',
						},
					}}
				>
					<Toolbar>
						<BtnBold />
						<BtnItalic />
						<BtnUnderline />
						<BtnNumberedList />
						<BtnBulletList />
						<BtnAlignLeft />
						<BtnAlignCenter />
						<BtnAlignRight />
						<BtnLink />
						<BtnClearFormatting />
					</Toolbar>
				</Editor>
			</EditorProvider>
		</div>
	)
}

export const isRichTextEmpty = value => {
	const text = `${value || ''}`
		.replace(/<[^>]+>/g, ' ')
		.replace(/&nbsp;/gi, ' ')
		.replace(/\s+/g, ' ')
		.trim()
	return !text
}
